import axios from 'axios';

const API_BASE = '/api';

const api = axios.create({ baseURL: API_BASE, timeout: 10000 });

export const gameAPI = {
  getFeatured: () => api.get('/games/featured').then(r => r.data),
  getGames: (params) => api.get('/games', { params }).then(r => r.data),
  getGame: (id) => api.get(`/games/${id}`).then(r => r.data),
  search: (query) => api.get(`/games/search/${encodeURIComponent(query)}`).then(r => r.data),
  searchGames: (query) => api.get(`/games/search/${encodeURIComponent(query)}`).then(r => r.data),
  getCategories: () => api.get('/categories').then(r => r.data),
  getPSPlus: () => api.get('/psplus').then(r => r.data),
  getDonates: () => api.get('/donates').then(r => r.data),
  getCollections: () => api.get('/collections').then(r => r.data),
  getPriceRanges: () => api.get('/games/price-ranges').then(r => r.data),
  getPreorders: () => api.get('/preorders').then(r => r.data),
};

export default api;
